import { useCallback, useState } from 'react';
import { getAssetTypes } from 'services/asset';
import { AssetTypes, ParamGetAssetModels } from '../app/pages/ValidationsPage/type';
const SizeOptionParams = 500;
export const useFetchAssetType = () => {
  const [optionAsset, setOptionAsset] = useState<{ label: string; value: string }[]>([]);
  const [hasMoreOptionAsset, setHasMoreOptionAsset] = useState<boolean>(false);
  const [pageOptionAsset, setPageOptionAsset] = useState<number>(1);
  const [isLoadingMore, setIsLoadingMore] = useState<boolean>(false);

  //START func get option type

  const getOptionAsset = useCallback(async (params: Partial<ParamGetAssetModels>) => {
    const data = (await getAssetTypes(params)) as { types: AssetTypes[]; total: number };
    const dataConvert = data?.types?.map((item) => ({
      value: item.id.toString(),
      label: item.name
    }));
    setOptionAsset(dataConvert);
    if (data.total <= SizeOptionParams) {
      setHasMoreOptionAsset(false);
      return;
    }
    setHasMoreOptionAsset(true);
    setPageOptionAsset(2);
  }, []);

  const handleFetchMoreOptionAsset = useCallback(async () => {
    if (!hasMoreOptionAsset || isLoadingMore) return;
    try {
      const paramsConvert = {
        page: pageOptionAsset,
        size: SizeOptionParams
      };
      setIsLoadingMore(true);
      const data = (await getAssetTypes(paramsConvert)) as { types: AssetTypes[]; total: number };
      const dataConvert = data?.types?.map((item) => ({
        value: item.id.toString(),
        label: item.name
      }));
      setOptionAsset([...optionAsset, ...dataConvert]);
      if (data.total <= SizeOptionParams * pageOptionAsset) {
        setHasMoreOptionAsset(false);
        return;
      }
      setHasMoreOptionAsset(true);
      setPageOptionAsset(pageOptionAsset + 1);
    } finally {
      setIsLoadingMore(false);
    }
  }, [hasMoreOptionAsset, isLoadingMore, pageOptionAsset, optionAsset]);

  return {
    getOptionAsset,
    optionAsset,
    hasMoreOptionAsset,
    handleFetchMoreOptionAsset,
    isLoadingMore,
    setPageOptionAsset
  };
};
